<template>
  <div class="business-meal">
    <!-- 轮播图 -->
    <div class="banner">
      <div class="swiper-wrapper">
        <div class="swiper-slide"><img src="@/assets/goyb02.png" alt="" /></div>
        <div class="swiper-slide"><img src="@/assets/goyb03.png" alt="" /></div>
        <div class="swiper-slide"><img src="@/assets/goyb01.png" alt="" /></div>
      </div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>

    <!-- 页面标题 -->
    <div class="page-header">
      <h1 class="title">商务餐</h1>
      <div class="title-line"></div>
    </div>

    <!-- 交替图片区域（原 content1） -->
    <div class="alternate-section">
      <div class="alternate-grid">
        <div class="alternate-row">
          <div class="img-card wow animate__animated animate__fadeInLeft" data-wow-delay="0.5s">
            <img src="../../assets/swc/a02.jpg" alt="商务餐" />
          </div>
          <div class="img-card wow animate__animated animate__fadeInRight" data-wow-delay="1s" style="margin-top: 60px;">
            <img src="../../assets/swc/a03.jpg" alt="商务餐" />
          </div>
        </div>
        <div class="alternate-row">
          <div class="img-card wow animate__animated animate__fadeInLeft" data-wow-delay="0.5s">
            <img src="../../assets/swc/a04.jpg" alt="商务餐" />
          </div>
          <div class="img-card wow animate__animated animate__fadeInRight" data-wow-delay="1s" style="margin-top: 60px;">
            <img src="../../assets/swc/a05.jpg" alt="商务餐" />
          </div>
        </div>
        <div class="alternate-row">
          <div class="img-card wow animate__animated animate__fadeInLeft" data-wow-delay="0.5s">
            <img src="../../assets/swc/a06.jpg" alt="商务餐" />
          </div>
          <div class="img-card wow animate__animated animate__fadeInRight" data-wow-delay="1s" style="margin-top: 60px;">
            <img src="../../assets/swc/a07.jpg" alt="商务餐" />
          </div>
        </div>
        <div class="alternate-row">
          <div class="img-card wow animate__animated animate__fadeInLeft" data-wow-delay="0.5s">
            <img src="../../assets/dxal/hw-a5.png" alt="商务餐" />
          </div>
          <div class="img-card wow animate__animated animate__fadeInRight" data-wow-delay="1s" style="margin-top: 60px;">
            <img src="../../assets/dxal/hw-a7.png" alt="商务餐" />
          </div>
        </div>
      </div>
    </div>

    <!-- 网格图片区域（原 content2） -->
    <div class="gallery-section">
      <div class="gallery-grid">
        <div v-for="(img, idx) in galleryImages" :key="idx" class="grid-item wow animate__animated animate__zoomIn" data-wow-delay="0.1s">
          <div class="img-wrapper">
            <img :src="img" alt="商务餐展示" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import { WOW } from 'wowjs'

export default {
  data() {
    return {
      galleryImages: [
        require('../../assets/swc/b01.jpg'),
        require('../../assets/swc/b02.jpg'),
        require('../../assets/swc/b03.jpg'),
        require('../../assets/swc/b04.jpg'),
        require('../../assets/swc/b05.jpg'),
        require('../../assets/swc/b06.jpg'),
        require('../../assets/swc/b07.jpg'),
        require('../../assets/swc/b08.jpg'),
        require('../../assets/swc/b09.jpg'),
        require('../../assets/swc/b10.jpg'),
        require('../../assets/swc/b11.jpg'),
        require('../../assets/swc/b12.jpg'),
        require('../../assets/swc/b13.jpg'),
        require('../../assets/swc/b14.jpg'),
        require('../../assets/swc/b15.jpg'),
        require('../../assets/swc/b16.jpg'),
        require('../../assets/swc/b17.jpg'),
        require('../../assets/swc/b18.jpg'),
        require('../../assets/swc/b19.jpg'),
        require('../../assets/swc/b20.jpg'),
        require('../../assets/swc/b21.jpg'),
        require('../../assets/swc/b22.jpg'),
        require('../../assets/swc/b23.jpg'),
        require('../../assets/swc/b24.jpg'),
        require('../../assets/swc/b26.jpg'),
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      const wow = new WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: true,
        live: true
      })
      wow.init()
    })
    new Swiper(".banner", {
      loop: true,
      pagination: { el: ".swiper-pagination" },
      navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
      autoplay: { autoplay: true, disableOnInteraction: false }
    })
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* 轮播图 */
.banner {
  width: 100%;
  height: 480px;
  overflow: hidden;
  position: relative;
}
.banner img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}
.banner .swiper-slide:hover img {
  transform: scale(1.03);
}
.swiper-button-prev,
.swiper-button-next {
  color: white;
  background: rgba(0, 0, 0, 0.4);
  width: 44px;
  height: 44px;
  border-radius: 50%;
  backdrop-filter: blur(4px);
}
.swiper-button-prev:after,
.swiper-button-next:after {
  font-size: 20px;
}

/* 页面头部 */
.page-header {
  text-align: center;
  margin: 48px 0 40px;
}
.title {
  font-size: 30px;
  font-weight: 700;
  color: #f97316;
  letter-spacing: 2px;
  margin-bottom: 16px;
}
.title-line {
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #f97316, #facc15);
  margin: 0 auto;
  border-radius: 2px;
}

/* 交替图片区域 */
.alternate-section {
  background-color: #ffffff;
  padding: 40px 0;
}
.alternate-grid {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}
.alternate-row {
  display: flex;
  gap: 32px;
  margin-bottom: 64px;
  flex-wrap: wrap;
  justify-content: center;
}
.img-card {
  flex: 1;
  min-width: 280px;
      height: 320px;
  background: #fff;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 20px 30px -12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s, box-shadow 0.3s;
}
.img-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 25px 40px -12px rgba(0, 0, 0, 0.2);
}
.img-card img {
  width: 100%;
  height: 320px;
  object-fit: cover;
  display: block;
  transition: transform 0.5s;
}
.img-card:hover img {
  transform: scale(1.05);
}

/* 网格图片区域 */
.gallery-section {
  background-color: #f8fafc;
  padding: 40px 0;
}
.gallery-grid {
  max-width: 80%;
  margin: 0 auto;
  padding: 0 24px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 30px;
}
.grid-item {
  overflow: hidden;
  border-radius: 20px;
  box-shadow: 0 12px 24px -8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
}
.grid-item:hover {
  transform: translateY(-6px);
  box-shadow: 0 20px 30px -10px rgba(0, 0, 0, 0.15);
}
.img-wrapper {
  width: 100%;
  height: 240px;
  overflow: hidden;
}
.img-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.4s;
}
.grid-item:hover img {
  transform: scale(1.05);
}

/* 响应式调整 */
/* @media (max-width: 992px) {
  .banner {
    height: 360px;
  }
  .title {
    font-size: 2rem;
  }
  .alternate-row {
    gap: 24px;
  }
  .img-card img {
    height: 280px;
  }
  .gallery-grid {
    gap: 20px;
  }
  .img-wrapper {
    height: 220px;
  }
} */

/* @media (max-width: 640px) {
  .banner {
    height: 260px;
  }
  .title {
    font-size: 1.8rem;
  }
  .alternate-row {
    margin-bottom: 40px;
  }
  .img-card img {
    height: 220px;
  }
  .gallery-grid {
    grid-template-columns: 1fr;
    gap: 24px;
  }
  .img-wrapper {
    height: 200px;
  }
} */
</style>